import {ViewRef} from "@angular/core";
import {Subscription} from "rxjs";
import {FUIStackedComponentRef} from "../stacked-page.service";
import {FUIStackedPageContextService} from "../stacked-page-context.service";

export class FUIStackedComponentRefView {
    constructor(public componentRef: FUIStackedComponentRef,
                public viewRef: ViewRef,
                public context: FUIStackedPageContextService,
                public subscription: Subscription[]) {
    }
}
